/**
 * @desc sendTaskCreateEvent
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(data: defs.FlowTaskCreateEvent): Promise<any> {
  return defHttp.post({
    url: '/flow/task/create/event',
    data,
  });
}

export function mock(data: defs.FlowTaskCreateEvent): Promise<any> {
  return defHttp.post({
    url: '/mock/flow/task/create/event',
    data,
  });
}
